import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import RouteThumbnailsFullTreeContainer from '@Pages/RetroSynthesis/RouteTree/RouteThumbnailsFullTreeContainer';
import { LinkElement } from '@els/els-react--link-element';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { useRouteMatch } from 'react-router-dom';

import './RouteThumbnailsPopup.scss';

export function RouteThumbnailsPopUpFooter({ path, onClick }) {
  return (
    <div className="route-thumbnail-popup__footer">
      <LinkElement href={`#${path}`} iconSprite="ChevronRight" iconRight onClick={onClick} className="e2e-project-route-tree-view">
        Tree view
      </LinkElement>
    </div>
  );
}

function RouteThumbnailsPopup({ tree, routeName, routeId, selfClose, ...rest }) {
  const match = useRouteMatch(RsRoute.PROJECT);
  const { projectId } = (match && match.params) || {};
  const treeViewPath = RsRoute.getProjectRouteTreeViewLink(projectId, routeId);

  return (
    <GeneralDialogLayout
      {...rest}
      selfClose={selfClose}
      size="sm"
      movable={false}
      className="react-dialogs-scrollable route-overview-tree-popup"
      header={<h4>{routeName}</h4>}
      footer={<RouteThumbnailsPopUpFooter path={treeViewPath} onClick={selfClose} />}>
      <div className="route-thumbnail-popup route-overview-tree-popup__container">
        <RouteThumbnailsFullTreeContainer tree={tree} />
      </div>
    </GeneralDialogLayout>
  );
}

RouteThumbnailsPopup.propTypes = {
  treeList: PropTypes.array,
};

export const typeOfRouteThumbnailDialog = 'typeOfRouteThumbnailDialog';
export default RouteThumbnailsPopup;
